import { render, staticRenderFns } from "./Container.vue?vue&type=template&id=c1877f70&scoped=true"
import script from "./Container.js?vue&type=script&lang=js&external"
export * from "./Container.js?vue&type=script&lang=js&external"
import style0 from "./Container.scss?vue&type=style&index=0&id=c1877f70&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1877f70",
  null
  
)

export default component.exports